import { billing as BillingApi } from '@teem/constants/api';
import { messages as i18n } from '@teem/constants/messages';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import * as moment from 'moment';


export class InvoiceTransactionHistory {
	containerContext: any;
	serverUrl: string = `${BillingApi.invoiceTransactionHistory}`;
	headers: Array<object> = [
		// { "label": $localize`:@@ts.billing.invoice_hash:Invoice #`, "thClass": "th-number" },
		{ "label": "#", "thClass": "th-number" },
		{ "label": $localize`:@@ts.billing.subscription:Subscription`, "thClass": "th-plans" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.billing.description:Description`, "thClass": "th-client" },
		{ "label": $localize`:@@ts.billing.method:Method`, "thClass": "th-bayanPay" },
		{ "label": $localize`:@@ts.billing.total:Total`, "thClass": "th-amount" },
		{ "label": $localize`:@@ts.billing.status:Status`, "thClass": "th-payment" }
	];

	cols: Array<object> = [
		{
			"key": "receipt_number",
			"tdClass": "td-number",
			"render": (value) => {
				return `<a href="javascript:void(0);" class="invoice_number"> ${value}</a>`
			},
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('invoice_number')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW_INVOICE_TRANSACTION, row);
				}
			},
		},
		{
			"key": "plan_name",
			"tdClass": "td-plans",
			"render": (value) => `<span class="subscription basic">${value}</span>`
		},
		{
			"key": "transaction_date",
			"tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (
						`<div class="date">
								<span class="day">${d.format('DD')}</span>
								<span class="month">${d.format('MMM')}</span>
								<span class="year">${d.format('YYYY')}</span>
						</div>`);
				}
				return '';
			}
		},
		{
			"key": "plan_type",
			"tdClass": "td-description",
			"render": (value) => `Membership Plan: ${value}</span>`
		},
		{
			"key": "card_id",
			"tdClass": "td-bayanPay",
		},
		{
			"key": "amount",
			"tdClass": "td-amount",
			"render": (value) => { return value ? value : 0 }
		},
		{
			"key": "status",
			"tdClass": "td-payment",
			"render": (value, row) => {

				let status = i18n[value] ? i18n[value] : i18n.pending;

				let colorClass = "highlight";

				if (value == 'paid') {
					colorClass = 'success';
				} else if (value == 'partially') {
					colorClass = 'warning';
				}

				return `<span class="status-tag ${colorClass}">${status}</span>`
			}
		}
	];
	constructor(container: any) {
		this.containerContext = container;
	}
}
